export default "__VITE_ASSET__f3c0d7ca__"